// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__uKbds","fade":"Overlay_fade__UT9+D","opening":"Overlay_opening__HkJAA","closing":"Overlay_closing__Y8MCj"};